var React = require('react');

function Customers (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}")),React.createElement("path",{"className":"a","d":"M13.5,14a2.5,2.5,0,0,1-3,0","key":1}),React.createElement("path",{"className":"a","d":"M23,23.5v-.106a1.976,1.976,0,0,0-.77-1.579C20.9,20.8,17.73,19,12,19S3.105,20.8,1.77,21.815A1.976,1.976,0,0,0,1,23.394V23.5","key":2}),React.createElement("path",{"className":"a","d":"M14,11.25a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25","key":3}),React.createElement("path",{"className":"a","d":"M10,11.25a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25","key":4}),React.createElement("path",{"className":"a","d":"M8.083,19.312a4,4,0,0,0,7.834,0","key":5}),React.createElement("path",{"className":"a","d":"M10.457,3.7A6,6,0,0,0,6,9.5v2a6,6,0,0,0,12,0v-2a6,6,0,0,0-4.457-5.8","key":6}),React.createElement("path",{"className":"a","d":"M12.566,7.5H11.434a.5.5,0,0,1-.495-.429l-.776-5.43A1,1,0,0,1,11.153.5h1.694a1,1,0,0,1,.99,1.141l-.776,5.43A.5.5,0,0,1,12.566,7.5Z","key":7})]);
}

Customers.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Customers;

Customers.default = Customers;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/customers.svg
// module id = 1067
// module chunks = 0